import { React, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";

const LayerControls = ({
  visibleLayers,
  onLayerToggle,
  selectedVariable,
  onVariableChange,
  variableOptions = [],
  selectedDateTime,
  onDateTimeChange,
  display_mode,
  sawti_modified_dt,
  nfdrs_modified_dt
}) => {

  const BackOneHr = () => {
    onDateTimeChange(moment(selectedDateTime).subtract(1,'H'));
  }
  const BackOneDay = () => {
    onDateTimeChange(moment(selectedDateTime).subtract(1,'d'));
  }
  const ForwardOneHr = () => {
    onDateTimeChange(moment(selectedDateTime).add(1,'H'));
  }
  const ForwardOneDay = () => {
    onDateTimeChange(moment(selectedDateTime).add(1,'d'));
  }


    const now = moment.utc();
    const sdate = moment(now).subtract(14,'d')
    const [disableForwardOneDay, setDisableForwardOneDay] = useState(false);
    const [disableForwardOneHr, setDisableForwardOneHr] = useState(false);
    const [disableBackOneDay, setDisableBackOneDay] = useState(false);
    const [disableBackOneHr, setDisableBackOneHr] = useState(false)
    useEffect(() => {
        // disable move forward one day
        if (moment(selectedDateTime).format("YYYY-MM-DD") === now.format("YYYY-MM-DD")){
            setDisableForwardOneDay(true);
        } else {
            setDisableForwardOneDay(false);
        }


        // disable move forward one hour
        if (moment(selectedDateTime).format("YYYY-MM-DD HH") === now.format("YYYY-MM-DD HH")){
            setDisableForwardOneHr(true);
        } else {
            setDisableForwardOneHr(false);
        }

        // disable move back one day
        if (moment(sdate).format("YYYY-MM-DD") === moment(selectedDateTime).format("YYYY-MM-DD")){
            setDisableBackOneDay(true);
        } else {
            setDisableBackOneDay(false);
        }

        // disable move back one hr
        if (moment(sdate).format("YYYY-MM-DD") === moment(selectedDateTime).format("YYYY-MM-DD")){
            setDisableBackOneHr(true);
        } else {
            setDisableBackOneHr(false);
        }

    }, [selectedDateTime]);

  return (
    <div
      style={{
        //padding: "12px",
        //borderRadius: "8px",
        //boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        width: "250px",
      }}
    >
      <h5>Map Layers</h5>
      <div className="checkboxes">
        <label >
            <input
            type="checkbox"
            checked={visibleLayers.chge}
            onChange={() => onLayerToggle("chge")}
            />
            CHGE Zones
        </label>
        <br />
        <label>
            <input
            type="checkbox"
            checked={visibleLayers.nys}
            onChange={() => onLayerToggle("nys")}
            />
            NYS Border
        </label>
        <br />
        <label>
            <input
            type="checkbox"
            checked={visibleLayers.counties}
            onChange={() => onLayerToggle("counties")}
            />
            NYS Counties
        </label>

        <br />
        <label>
            <input
            type="checkbox"
            checked={visibleLayers.fdras}
            onChange={() => onLayerToggle("fdras")}
            />
            FDRA
        </label>

        <br />
        <label>
            <input
            type="checkbox"
            checked={visibleLayers.incidents}
            onChange={() => onLayerToggle("incidents")}
            />
            Incidents
        </label>

        <br />

        <label>
            <input
            type="checkbox"
            checked={visibleLayers.radar}
            onChange={() => onLayerToggle("radar")}
            />
            Radar
        </label>

        <br />

        <label>
            <input
            type="checkbox"
            checked={visibleLayers.alerts}
            onChange={() => onLayerToggle("alerts")}
            />
            NWS Alerts
        </label>

        <br />
        <label>
            <input
            type="checkbox"
            checked={visibleLayers.lightning}
            onChange={() => onLayerToggle("lightning")}
            />
            Lightning
        </label>


      </div>

      


      <hr />
    {display_mode === "obs" && (
        <div>

        <h5 htmlFor="date">Select Date (EST):</h5>
        <DatePicker 
            selected={selectedDateTime ? new Date(selectedDateTime) : null}
            onChange={(date) => onDateTimeChange(moment(date).utc())}
            showTimeSelect
            maxDate={new Date()} // max selectable date: today
            minDate={new Date(new Date().setDate(new Date().getDate() - 14))} // min selectable date: two weeks ago
            dateFormat="yyyy-MM-dd HH:00"
            popperModifiers={{
                preventOverflow: {
                    enabled: true, 
                },
            }}
        />
        <br />
        
        <button className="button--primary" style={{width: "40%"}} onClick={() => BackOneHr()} disabled={disableBackOneHr}> -1h </button>
        <button className="button--primary" style={{width: "40%"}} onClick={() => ForwardOneHr()} disabled={disableForwardOneHr}> +1h </button>
        <button className="button--primary" style={{width: "40%"}} onClick={() => BackOneDay()} disabled={disableBackOneDay}> -1 day </button>
        <button className="button--primary" style={{width: "40%"}} onClick={() => ForwardOneDay()} disabled={disableForwardOneDay}> +1 day </button>

        <hr />

            <h5>Select Data</h5>
            <select
                value={selectedVariable || ""}
                onChange={(e) => onVariableChange(e.target.value)}
                style={{ width: "100%", padding: "6px", borderRadius: "4px" }}
            >
                <option value="">Select variable...</option>
                {variableOptions.map((v) => (
                <option key={v.value} value={v.value}>
                    {v.label}
                </option>
                ))}
            </select>
        <hr />

        </div>

    )}

    {/* **************************** */}
    {/* ***Parameter Descriptions*** */}
    {/* **************************** */}

    {(display_mode == "forecast") && (
        <div>
            <h5>SAWTI</h5>
            <p>
The Santa Ana Wildfire Threat Index (SAWTI) is an index designed to estimate the risk of fire spread on a given day. It accounts for temperature, relative humidity, wind speed, and recent precipitation. The index is used to forecast the risk of fire spread using weather models, and it can estimate the current risk using observed weather information, such as that produced by the NYS Mesonet.
<br/> (0=nill, >10 = danger)
            </p>
        </div>
    )}


    {(selectedVariable === "sawti" && display_mode != "forecast") && (
        <div>
            <h5>SAWTI</h5>
            <h6>{sawti_modified_dt}</h6>
            <p>
The Santa Ana Wildfire Threat Index (SAWTI) is an index designed to estimate the risk of fire spread on a given day. It accounts for temperature, relative humidity, wind speed, and recent precipitation. The index is used to forecast the risk of fire spread using weather models, and it can estimate the current risk using observed weather information, such as that produced by the NYS Mesonet.
<br/> (0=nill, >10 = danger)
            </p>
        </div>
    )}

    {(selectedVariable === "tenhrfm" && display_mode != "forecast") && (
        <div>
            <h5>10 Hour Dead Fuel Moisture</h5>
            {/* <h6>{nfdrs_modified_dt}</h6> */}
            <p>
10-hour fuel moisture is calculated using the Nelson model. This index measures the moisture content in small, fine fuels like grass, leaves, and twigs less than 1 inch in diameter. The model rapidly reflects environmental changes, as these fine fuels adjust their moisture content in about 10 hours. A low 10-hour index indicates dry, highly flammable fuels, while a high index suggests moister, less ignitable conditions. This short-term moisture response helps assess immediate fire risks.
            </p>
        </div>
    )}

    {(selectedVariable === "hunhrfm" && display_mode != "forecast") && (
        <div>
            <h5>100 Hour Dead Fuel Moisture</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
100-hour fuel moisture is calculated using the Nelson model. This index measures the moisture in medium-sized fuels, like branches and twigs between 1 and 3 inches in diameter. These fuels respond more slowly to weather changes, taking roughly 100 hours to reach moisture equilibrium. The Nelson model factors in environmental conditions over this longer period. A lower index means the fuels are dry and pose a higher fire risk, while a higher index indicates moister fuels, which are less prone to ignition.            
            </p>
        </div>
    )}

    {(selectedVariable === "thhrfm" && display_mode != "forecast") && (
        <div>
            <h5>1000 Hour Dead Fuel Moisture</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
1000-hour fuel moisture index is calculated using the Nelson model. This index measures the moisture for large fuels, such as logs and heavy branches over 3 inches in diameter. These fuels take about 1000 hours (roughly 42 days) to adjust to environmental moisture conditions. A low 1000-hour fuel moisture index indicates extreme dryness in these heavy fuels, suggesting higher potential for sustained, intense fires. A high index reflects moister conditions, reducing the risk of long-duration burning.            
            </p>
        </div>
    )}


    {(selectedVariable === "ignition_component" && display_mode != "forecast") && (
        <div>
            <h5>Ignition Component</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
The Ignition Component (IC) estimates the likelihood that a firebrand will start a fire requiring suppression efforts. This is primarily influenced by the moisture content of fine fuels, which have a 1-hour time lag, and the temperature of those receptive fuels. IC is expressed as a probability percentage ranging from 1 to 100 and does not have specific units.
            </p>
        </div>
    )}

    {(selectedVariable === "spread_component" && display_mode != "forecast") && (
        <div>
            <h5>Spread Component</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
The Spread Component (SC) measures the forward rate at which a head fire advances. It accounts for factors such as wind, slope, and the characteristics of both the fuel bed and fuel particles. Daily fluctuations in SC are influenced by changes in wind conditions and the moisture levels of live fuels, as well as dead fuels in the 1-hour, 10-hour, and 100-hour time lag categories.
            </p>
        </div>
    )}

    {(selectedVariable === "energy_release_component" && display_mode != "forecast") && (
        <div>
            <h5>Energy Release Component</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
The Energy Release Component (ERC) represents the estimated potential energy released per unit area in a fire's flaming zone. Like the Spread Component (SC), it depends on fuel characteristics. Day-to-day changes in ERC result from shifts in moisture levels across various fuel classes, including the 1000-hour time lag category. ERC is calculated based on the predicted heat release rate per unit area during flaming combustion and the duration of burning, expressed in BTUs per square foot.
            </p>
        </div>
    )}

    {(selectedVariable === "burning_index" && display_mode != "forecast") && (
        <div>
            <h5>Burning Index</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
The Burning Index (BI) is an indicator of fire intensity. It combines the Spread Component (SC) and Energy Release Component (ERC) to reflect how fire behavior impacts the difficulty of controlling a fire. While BI has no specific units, it generally correlates to ten times the flame length of a fire.
            </p>
        </div>
    )}

    {(selectedVariable === "kbdi" && display_mode != "forecast") && (
        <div>
            <h5>KBDI</h5>
            <h6>{nfdrs_modified_dt}</h6>
            <p>
The Keetch-Byram Drought Index (KBDI) evaluates fire risk by reflecting the balance between evapotranspiration and precipitation, which leads to a cumulative moisture shortfall in deep duff and upper soil layers.

KBDI aims to estimate the amount of rainfall needed to restore the soil to its full moisture-holding capacity. The index ranges from zero, indicating no moisture deficit, to 800, representing the highest possible drought level. This scale correlates with a moisture level between 0 and 8 inches in the soil, with 8 inches indicating saturation. The index value at any point shows how much net rainfall is needed to bring the soil back to full moisture, or saturation. 
            </p>
        </div>
    )}


    </div>
  );
};

export default LayerControls;
